import { useFlags } from 'launchdarkly-react-client-sdk';
import { FeatureFlag } from 'types';

export function useFeatureFlag(flag: FeatureFlag): boolean {
  const flags = useFlags();

  return flags[flag] || false;
}
